import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useAdminExportTemplate = () => {
  return useMutation({
    mutationFn: async (templateId: string) => {
      const response = await request({
        path: `template/export-template/${templateId}`,
        method: 'GET',
        authenticate: true,
        responseType: 'blob',
      });

      return { data: response, templateId };
    },
    onSuccess: ({ data, templateId }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `template-${templateId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Template export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting template');
    },
  });
};
